import apiClient, { ApiResponse } from './client';

export type CustomDomainStatus = 'pending' | 'active' | 'failed';

export interface CustomDomain {
  domain: string;
  status: CustomDomainStatus;
  cloudflare_status: string | null;
  failure_reason: string | null;
  last_checked_at: string | null;
  created_at: string | null;
  updated_at: string | null;
}

export interface CustomDomainStateResponse {
  custom_domain: CustomDomain | null;
  dns_target: string;
}

export interface CustomDomainCreateRequest {
  domain: string;
}

class CustomDomainsService {
  async getCustomDomain(
    organizationId: string,
    forceRefresh = false,
  ): Promise<ApiResponse<CustomDomainStateResponse>> {
    return apiClient.get<CustomDomainStateResponse>(
      `/api/organizations/${organizationId}/custom-domain`,
      forceRefresh ? { force_refresh: 'true' } : undefined,
    );
  }

  async createCustomDomain(
    organizationId: string,
    data: CustomDomainCreateRequest,
  ): Promise<ApiResponse<CustomDomainStateResponse>> {
    return apiClient.post<CustomDomainStateResponse>(
      `/api/organizations/${organizationId}/custom-domain`,
      data,
    );
  }

  async deleteCustomDomain(
    organizationId: string,
  ): Promise<ApiResponse<{ success: boolean }>> {
    return apiClient.delete<{ success: boolean }>(
      `/api/organizations/${organizationId}/custom-domain`,
    );
  }
}

const customDomainsService = new CustomDomainsService();
export default customDomainsService;
